import React, { useState } from "react";
import Cookies from "js-cookie";
import Button from "react-bootstrap/Button";
import { cookieName } from "../utils";
import tcbase from "../shim/tcbase";

const CookiePopup = () => {
  const [shouldDisplay, setShouldDisplay] = useState(!Cookies.get(cookieName));
  const { userName } = tcbase || {};

  const setCookie = () => {
    Cookies.set(cookieName, true);
    setShouldDisplay(false);
  };

  return shouldDisplay && userName ? (
    <div className="cookie-popup-wrapper">
      <p>
        This website uses cookies to ensure the best website experience. By
        continuing to use this website you are giving your consent to cookies
        being used. Detailed information about our use of cookies is{" "}
        <span>
          <a href="/cookie_policy">here</a>
        </span>
        .
        <br />
        <Button onClick={setCookie} size="sm">
          Accept
        </Button>
      </p>
    </div>
  ) : (
    ""
  );
};

export default CookiePopup;
